import { Alert, AlertTitle, Box, Button, Grow, Icon, Modal, Typography, useMediaQuery } from "@mui/material";
import { ICarrito } from "../../redux/models/typesInformes";
import { useAppSelector } from "../../redux/store";

type ModalVerNotasProps = {
    open: boolean
    onCancel: () => void
    carpeta?: ICarrito
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    boxShadow: 24,
    p: 4,
    borderRadius: '12px', // Redondear bordes
};


const ModalVerNotas = ({ carpeta, open, onCancel }: ModalVerNotasProps) => {
    const darkMode = useAppSelector(state => state.theme.darkTheme)

    const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
    const boxWidth = isMobile ? '90%' : '40rem'

    const { pdfObserved } = carpeta || {}

    const handleDownload = () => {

        if (pdfObserved) {
            window.open(pdfObserved, "_blank")
        }

    }


    return (
        <Modal
            open={open}
            onClose={onCancel}
            aria-labelledby={`observar-carpeta-${carpeta?.idCarrito}`}
            sx={{
                width: '100%',
            }}
        >
            <Box sx={(theme) => ({
                ...style,
                width: boxWidth,
                overflow: 'auto',
                maxHeight: '100%',
                bgcolor: darkMode ? '#1e1e1e' : '#fff',
                border: darkMode ? '1px solid #444' : '1px solid #ddd',
            })}
                aria-label={`observar-carpeta-${carpeta?.idCarrito}`}
            >
                <Alert severity="info" sx={{ mb: 3, borderRadius: '8px' }}>
                    <AlertTitle sx={{ fontSize: '1.5rem' }}>AVISO</AlertTitle>
                </Alert>



                <Typography variant='body1' sx={{
                    fontSize: '1.55rem',
                    lineHeight: 1.6,
                    mb: 4,
                    textAlign: 'justify'
                }}>
                    {carpeta?.observedReason}
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, columnGap: '1rem' }}>
                    <Grow in={pdfObserved ? true : false}>
                        <Button
                            variant='contained'
                            startIcon={<Icon>get_app</Icon>}
                            sx={(theme) => ({
                                px: 3,
                                py: 1.5,
                                fontSize: '1rem',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                                bgcolor: theme.palette.mode === 'dark' ? '#444' : '#fff',
                                color: theme.palette.mode === 'dark' ? '#fff' : '#000',
                                '&:hover': {
                                    bgcolor: theme.palette.mode === 'dark' ? '#333' : '#f0f0f0',
                                }
                            })}
                            onClick={handleDownload}
                        >
                            Descargar
                        </Button>
                    </Grow>
                    <Button
                        variant='contained'
                        color='primary'
                        sx={{
                            px: 3,
                            py: 1.5,
                            fontSize: '1rem',
                            borderRadius: '8px',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
                        }}
                        onClick={() => onCancel()}
                    >
                        Cerrar
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}

export default ModalVerNotas;
